// extracted by mini-css-extract-plugin
export var buttonContainer = "_50-1";
export var fontSizeSelect = "_50-3";
export var formatSelect = "_50-2";
export var formats = "_50-4";
export var hidden = "_50-5";
export var icon = "_50-6";
export var select = "_50-0";